import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { peopleApi } from '../services/api';

// Identity is now derived from the real Cognito login (matched to a nimbus Person
// record by email), rather than a manual "pretend to be X" picker — the tracker used
// to run with no real auth at all, so a client-side picker stood in for login.
export function useCurrentUser() {
  const { user } = useAuth();
  const { data: people = [] } = useQuery({ queryKey: ['people'], queryFn: peopleApi.getAll });

  const email = (user?.email || '').toLowerCase();
  const person = people.find((p: any) => (p.email || '').toLowerCase() === email);

  return { personId: person?.personId || '' };
}
